/** A short local date and time for "when was this measured" labels, like "Oct 7, 8:22 PM"; "" when unreadable. */
export const shortDateTime = (value: string | Date): string => {
  const when = value instanceof Date ? value : new Date(value);
  return Number.isNaN(when.getTime())
    ? ''
    : when.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
};
